import { Controller } from "@hotwired/stimulus"

// Controls the time entry rejection modal.
// Opens the modal, sets the form action for the given entry, and handles submit/close.
//
// Usage:
//   <div data-controller="reject-modal">
//     <button data-action="click->reject-modal#open"
//             data-reject-modal-entry-id-param="42">Reject</button>
//
//     <div data-reject-modal-target="modal" class="hidden">
//       <div data-action="click->reject-modal#close"><!-- backdrop --></div>
//       <form data-reject-modal-target="form">...</form>
//       <button data-action="click->reject-modal#submit">Reject Entry</button>
//       <button data-action="click->reject-modal#close">Cancel</button>
//     </div>
//   </div>
//
export default class extends Controller {
  static targets = ["modal", "form"]
  static values  = { basePath: { type: String, default: "/admin/time_entries" } }

  open(event) {
    const entryId = event.params.entryId
    this.formTarget.action = `${this.basePathValue}/${entryId}/reject`
    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.formTarget.reset()
  }

  submit() {
    this.formTarget.submit()
  }
}
